import { ClinicInvoice } from 'infrastructure/classes/clinic-invoice/clinic-invoice';
import { useQuery } from '@tanstack/react-query';
import { STALE_TIME } from 'infrastructure/consts/stale-time';

import useApi from '../use-api';

import type {
  IPartialPaginationMeta,
  IClinicInvoicesData,
} from 'infrastructure/interfaces';

const api = (clinicGuid: string) => `core-2/clinics/${clinicGuid}/invoices`;

interface IProps {
  clinicGuid: string;
}

export const useGetClinicInvoices = (props: IProps) => {
  const { clinicGuid } = props;
  const { loadData } = useApi();

  const queryKey = [api(clinicGuid)];

  const {
    data = [],
    isFetching,
    refetch,
  } = useQuery({
    queryKey,
    queryFn: () =>
      loadData<IClinicInvoicesData, Omit<IPartialPaginationMeta, 'sortField'>>(
        api(clinicGuid),
      ).then((res) => {
        if (res) {
          return res.map((el) => new ClinicInvoice(el));
        }
      }),
    staleTime: STALE_TIME,
    enabled: !!clinicGuid,
  });

  return {
    items: data,
    loading: isFetching,
    refetch,
  };
};
